import { SUBMIT_SCORES_LOADING, SUBMIT_SCORES_SUCCESS, SUBMIT_SCORES_ERROR } from "../../../constant/actionTypes";

const createScoreReducer = (state = {}, action) => {
    switch (action.type) {
        case SUBMIT_SCORES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case SUBMIT_SCORES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case SUBMIT_SCORES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createScoreReducer;